/**
 * Misión y UAS - Animaciones
 * Incluye: Magnetic Drone Effect + Staggered Checklist Reveal
 */

class MissionAnimations {
    constructor() {
        this.section = document.querySelector('.mision-uas');

        // Esta sección solo existe en la home. En about/academy no está,
        // así que salimos antes de tocar this.section (evita el TypeError
        // que rompía el ciclo de carga de Turbo en esas páginas).
        if (!this.section) return;

        this.droneContainer = document.querySelector('.drone-animation-container');
        this.droneBody = document.querySelector('.drone-body');
        this.checklistItems = document.querySelectorAll('.tech-checklist li');
        this.slideElements = this.section.querySelectorAll('.slide-in-element');

        this.hasTriggered = false;

        this.init();
    }

    init() {
        if (!this.section) return;

        this.setupIntersectionObserver();
        this.setupMagneticDrone();
    }

    setupIntersectionObserver() {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.2
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.hasTriggered) {
                    this.hasTriggered = true;
                    this.playEntryAnimations();
                }
            });
        }, options);

        observer.observe(this.section);
    }

    playEntryAnimations() {
        // General elements (Title, Text, CTA)
        this.slideElements.forEach((el, index) => {
            // Apply staggered delay based on DOM order
            // We assume checklist items are handled separately or part of this query if they have the class
            if (!el.classList.contains('tech-checklist')) {
                setTimeout(() => {
                    el.classList.add('slide-in-active');
                }, index * 100);
            }
        });

        // Specific handling for checklist items
        const checklist = document.querySelector('.tech-checklist');
        if (checklist) {
            setTimeout(() => {
                checklist.classList.add('slide-in-active');
                // Animate items inside
                this.checklistItems.forEach((item, idx) => {
                    item.style.opacity = '0';
                    item.style.transform = 'translateX(-10px)';
                    item.style.transition = 'all 0.4s ease-out';

                    setTimeout(() => {
                        item.style.opacity = '1';
                        item.style.transform = 'translateX(0)';
                    }, idx * 150);
                });
            }, 400); // Start after title/intro
        }
    }

    setupMagneticDrone() {
        if (!this.droneContainer || !this.droneBody) return;

        this.section.addEventListener('mousemove', (e) => {
            const { clientX, clientY } = e;
            const { innerWidth, innerHeight } = window;

            // Mouse relative pos (-1 to 1)
            const xPos = (clientX / innerWidth - 0.5) * 2;
            const yPos = (clientY / innerHeight - 0.5) * 2;

            // Move container slightly opposite to mouse (Parallax)
            this.droneContainer.style.transform = `translate(${xPos * -20}px, ${yPos * -20}px)`;
            this.droneContainer.style.transition = 'transform 0.1s ease-out';

            // Rotate drone body slightly for 3D feel
            this.droneBody.style.transform = `rotateX(${yPos * -10}deg) rotateY(${xPos * 10}deg)`;
            this.droneBody.style.transition = 'transform 0.1s ease-out';
        });

        this.section.addEventListener('mouseleave', () => {
            this.droneContainer.style.transform = 'translate(0,0)';
            this.droneContainer.style.transition = 'transform 0.8s ease-out';

            this.droneBody.style.transform = 'rotateX(0) rotateY(0)';
            this.droneBody.style.transition = 'transform 0.8s ease-out';
        });
    }
}

function initMissionAnimations() {
    new MissionAnimations();
}

document.addEventListener('DOMContentLoaded', initMissionAnimations);
document.addEventListener('turbo:load', initMissionAnimations);
